export enum SelectionModeKinds {
  Row = 1,
  Cell = 2,
}
